<template>
  <div class="chartDom" ref="chartDom"></div>
</template>
<script>
export default {
  props: {
    data: {
      type: Number,
      default: function() {
        return 0
      }
    }
  },
  data() {
    return {
      msg: '饼图-半径模式',
      echartParams: this.data,
      timeId: null,
      myChart: null
    }
  },
  created() {},
  mounted() {
    this.drawLineCustom(this.echartParams)
  },
  destroyed() {
    clearInterval(this.timeId)
  },
  methods: {
    drawLineCustom(params) {
      this.myChart = this.$echarts.init(this.$refs.chartDom)
      let option = {
        grid: {
          left: '45%',
          top: '40%',
          right: '5%',
          bottom: '10%',
          containLabel: true
        },

        xAxis: [
          {
            show: false
          }
        ],
        yAxis: [
          // 横向 进度条 顶部数字
          {
            axisLine: 'none',
            axisLabel: {
              show: false, // 隐藏
              textStyle: {
                color: '#ffffff',
                fontSize: '16'
              }
            },
            data: ['5']
          }
        ],
        // 圆形进度条 标题
        title: {
          text: params + '%',
          left: 'center',
          top: 'center',
          itemGap: 0,
          textStyle: {
            color: '#2469EF',
            fontSize: '12',
            fontWeight: '600'
          }
        },
        angleAxis: {
          max: 100,
          // 隐藏刻度线
          show: false,
          startAngle: 90
        },
        radiusAxis: {
          type: 'category',
          show: true,
          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        polar: {
          // radius: '120%', //图形大小
          radius: ['75%', '90%'], // 大小
          center: ['50%', '50%'] // 位置
        },
        series: [
          // 圆形 进度条
          {
            type: 'bar',
            data: [params],
            showBackground: true,
            roundCap: true,
            // 圆环 进度条背景颜色
            backgroundStyle: {
              color: '#CEDFEF'
            },
            coordinateSystem: 'polar',
            barWidth: 10,
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#80DCBC'
                    },
                    {
                      offset: 1,
                      color: '#43BAE6'
                    }
                  ],
                  global: false
                }
              }
            }
          }
        ]
      }

      this.myChart.setOption(option, true)

      window.addEventListener('resize', () => {
        if (this.myChart) {
          this.myChart.resize()
        }
      })
    }
  },

  watch: {
    data: {
      immediate: true,
      deep: true,
      handler: function(newValue, oldValue) {
        this.$nextTick(() => {
          clearInterval(this.timeId)
          this.drawLineCustom(newValue)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.chartDom {
  width: 30%;
  height: 100%;
}
</style>
